import React from 'react';
import { ArcaPlan } from '../../constants/arcaPlans';
import ReportSettingsCard, { ReportSettings } from './ReportSettingsCard';
import NewPlanProjectionCard from './NewPlanProjectionCard';
import NewPlanRetrospectiveCard from './NewPlanRetrospectiveCard';
import { PlanReturnView } from '../../utils/transferReturns';

interface NewPlanSimulatorProps {
	/** Plan Arca elegido (se proyecta en solitario, sin comparación). */
	resolvedPlan: ArcaPlan;
	/** Rentabilidad del plan, decidida por comparsa; `null` = sin datos (aviso, sin curva). */
	planReturn: PlanReturnView | null;
	settings: ReportSettings;
	onChange: (patch: Partial<ReportSettings>) => void;
	/** Aportación mensual máxima deducible (€). */
	maxMonthly: number;
	translate: (key: string) => string;
}

/**
 * Simulador del informe para un plan NUEVO (sin origen): card de ajustes (izquierda, solo
 * años y aportación) y gráfica de proyección de una sola línea a la derecha. Análogo a
 * `ReportSimulator` pero sin comparativa de origen ni retrospectiva.
 */
const NewPlanSimulator: React.FC<NewPlanSimulatorProps> = ({
	resolvedPlan,
	planReturn,
	settings,
	onChange,
	maxMonthly,
	translate
}) => {
	const planName = resolvedPlan.manager || resolvedPlan.name || 'Arca Digital';
	return (
		<div className="grid grid-cols-1 gap-4 lg:grid-cols-5 lg:items-stretch">
			<div className="lg:col-span-2">
				<ReportSettingsCard
					settings={settings}
					onChange={onChange}
					maxMonthly={maxMonthly}
					variant="newPlan"
					translate={translate}
				/>
			</div>
			<div className="flex flex-col gap-4 lg:col-span-3">
				{planReturn ? (
					<>
						<div className="flex-1">
							<NewPlanProjectionCard
								years={settings.years}
								monthlyContribution={settings.monthlyContribution}
								planReturn={planReturn}
								planName={planName}
								translate={translate}
							/>
						</div>
						<NewPlanRetrospectiveCard
							monthlyContribution={settings.monthlyContribution}
							planReturn={planReturn}
							planName={planName}
							translate={translate}
						/>
					</>
				) : (
					// Sin datos no se proyecta con una tasa inventada (guía v3.1).
					<div className="surface-card p-5 flex-1 flex items-center justify-center text-center">
						<p className="text-sm text-muted-foreground">
							{translate('individual.newPlanProjection.noData') ||
								'No tenemos la rentabilidad de este plan, así que no podemos proyectarlo.'}
						</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default NewPlanSimulator;
